import { Link } from 'react-router-dom';
import { productsData } from '../../../mocks/products';

const FeaturedProducts = () => {
  const featuredProducts = productsData.filter((p) => p.status === 'featured' || p.status === 'new').slice(0, 3);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full mb-6">
            <span className="text-secondary font-semibold text-sm">Öne Çıkan Ürünler</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 font-heading">
            2. El Bilgisayar ve Laptop Seçenekleri
          </h2>
          <p className="text-neutral-600 text-lg max-w-3xl mx-auto">
            Sıfır ayarında ikinci el bilgisayar ve laptop modellerimizi inceleyin. Tüm ürünlerimiz detaylı testlerden geçmiş ve garantilidir.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {featuredProducts.map((product) => (
            <div
              key={product.id}
              className="group bg-white rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden bg-neutral-100">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                {/* Status Badge */}
                <div className="absolute top-4 left-4">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      product.status === 'new'
                        ? 'bg-secondary text-white'
                        : 'bg-accent text-white'
                    }`}
                  >
                    {product.condition}
                  </span>
                </div>
                {/* Brand Badge */}
                <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-lg">
                  <span className="text-xs font-semibold text-primary">{product.brand}</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-primary mb-4 line-clamp-2">{product.name}</h3>

                {/* Specs */}
                <div className="space-y-2 mb-6">
                  <div className="flex items-center space-x-2 text-sm text-neutral-600">
                    <i className="ri-cpu-line text-accent"></i>
                    <span>{product.processor}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-neutral-600">
                    <i className="ri-database-2-line text-accent"></i>
                    <span>{product.ram}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-neutral-600">
                    <i className="ri-hard-drive-2-line text-accent"></i>
                    <span>{product.storage}</span>
                  </div>
                  {product.gpu && (
                    <div className="flex items-center space-x-2 text-sm text-neutral-600">
                      <i className="ri-gamepad-line text-accent"></i>
                      <span>{product.gpu}</span>
                    </div>
                  )}
                </div>

                {/* Rating */}
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                  ))}
                  <span className="text-sm text-neutral-600 ml-2">({product.rating}.0)</span>
                </div>

                {/* Price */}
                <div className="flex items-baseline space-x-2 mb-6">
                  {product.oldPrice && (
                    <span className="text-neutral-400 line-through text-sm">{product.oldPrice.toLocaleString('tr-TR')} ₺</span>
                  )}
                  <span className="text-2xl font-bold text-secondary">{product.price.toLocaleString('tr-TR')} ₺</span>
                </div>

                {/* Buttons */}
                <div className="grid grid-cols-2 gap-3">
                  <Link
                    to={`/urunler/${product.slug}`}
                    className="flex items-center justify-center px-4 py-3 border-2 border-primary text-primary rounded-lg font-semibold text-sm hover:bg-primary hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Detayları Gör
                  </Link>
                  <a
                    href="https://wa.me/905065376985"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-2 px-4 py-3 bg-whatsapp text-white rounded-lg font-semibold text-sm hover:bg-whatsapp/90 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line"></i>
                    <span>Sor</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <Link
            to="/urunler"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-primary text-white rounded-lg font-semibold hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>Tüm Ürünleri İncele</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;